/**
 * Courier & Logistics Domain API Service
 */

import { api } from './client';

export const courierAPI = {
  // Steadfast Courier integration endpoints
  sendOrderToSteadfast: async (orderId: number) => api.post(`/orders/${orderId}/send_to_steadfast/`),
  getSteadfastTracking: async (orderId: number) => api.get(`/orders/${orderId}/steadfast_tracking/`),
  bulkSendToSteadfast: async (orderIds: number[]) => api.post('/orders/bulk_send_to_steadfast/', { order_ids: orderIds }),
  bulkPickupRequest: async (orderIds: number[]) => api.post('/orders/bulk_pickup_request/', { order_ids: orderIds }),
  getCustomerSteadfastHistory: async (phone: string, refresh = false) => api.get(`/orders/customer_steadfast_history/?phone=${encodeURIComponent(phone)}${refresh ? '&refresh=true' : ''}`),
  batchCustomerCourierIntelligence: async (phones: string[]) => api.post('/orders/batch_customer_intelligence/', { phones }),
  syncSteadfastStatuses: async (orderIds?: number[]) => api.post('/orders/sync_steadfast_statuses/', orderIds ? { order_ids: orderIds } : {}),
  getSteadfastPoliceStations: async () => api.get('/admin/integrations/steadfast_police_stations/'),
};
